// packages
import { initFrame } from '@newswire/frames';

// stores
import { createOfficeRaceFeed } from './stores/national';

// components
import StatesToWatchEmbed from './components/StatesToWatchEmbed.svelte';

async function main() {
  const feed = await createOfficeRaceFeed('president');

  new StatesToWatchEmbed({
    target: document.getElementById('embed') as HTMLElement,
    props: {
      statesFeed: feed,
      includeLinks: false,
    },
  });

  initFrame();
}

main().catch(console.error);
